import { Box, ColorOptions, Text } from '@jfs/ui-new'
import { convertHexToRGBA } from '@jfs/ui-new/src/utils/utils'
import { useStores } from '../../../data/store'
import { addTwoDecimalZeroes } from '../../../utils'

interface PaymentHeadetrProps {
  text?: string
}

export const PaymentAmountHeader = ({ text = 'PAYABLE AMOUNT' }: PaymentHeadetrProps) => {
  const { netAmount, theme } = useStores((root) => ({
    netAmount: root?.getTransactionAmount(),
    theme: root?.config?.merchantTheme,
  }))
  return (
    <>
      <Box
        p={24}
        h={51}
        flexDirection="row"
        width={'100%'}
        align={'center'}
        justify={'space-between'}
        borderColor="GRAY_BORDER">
        <Text
          fontSize={12}
          fontFamily={'jioType-medium'}
          color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
          letterSpacing={1.1}>
          {text}
        </Text>
        <Text fontSize={16} fontFamily={'jioType-medium'} color={theme?.bodyTextColor as ColorOptions}>
          ₹ {addTwoDecimalZeroes(netAmount)}
        </Text>
      </Box>
    </>
  )
}
